import { Box, Divider, Paper, styled, Fade } from '@mui/material';
import { CanvasSelectionModeButtons } from './CanvasSelectionModeButtons';
import { CommentsButton } from './CommentsToolbarButton';
import { MetadataElementsToolbarButton } from './MetadataElementsToolbarButton';
import { TemplatesAndPluginsToolbarButton } from './TemplatesAndPluginsToolbarButton';
import { CanvasAddFunnelMenuButton } from './CanvasAddFunnelMenuButton';
import { useState } from 'react';
import { useForwardPinchToSweepCanvas } from '../../../../sweep-canvas/hooks/useForwardPinchToSweepCanvas';
import { CanvasSectionsToolbarButton } from './CanvasSectionsToolbarButton';
import { CanvasStickyNotesToolbarButton } from './CanvasStickyNotesToolbarButton';
import { colors } from '@sweep-io/sweep-design';
import { CanvasTextNodeToolbarButton } from './CanvasTextNodeToolbarButton';

const CanvasToolbarPaper = styled(Paper)({
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
});

const ButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '8px',
});

const ToolbarDivider = () => {
  return <Divider orientation="vertical" flexItem sx={{ borderColor: colors.grey[120] }} />;
};

export const CanvasToolbar = ({ isDisabled }: { isDisabled: boolean }) => {
  const [divRef, setDivRef] = useState<HTMLDivElement | null>(null);
  useForwardPinchToSweepCanvas({ element: divRef });

  return (
      <Fade in={true} timeout={1500}>
        <Box
          sx={{
            position: 'fixed',
            bottom: '16px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
          }}
          ref={setDivRef}
        >
          <CanvasToolbarPaper>
            <ButtonContainer>
              <CanvasSelectionModeButtons isDisabled={isDisabled} />
            </ButtonContainer>
            <ToolbarDivider />
            <ButtonContainer>
              <CanvasStickyNotesToolbarButton isDisabled={isDisabled} />
              <CanvasTextNodeToolbarButton isDisabled={isDisabled} />
              <CanvasSectionsToolbarButton isDisabled={isDisabled} />
              <CommentsButton isDisabled={isDisabled} />
            </ButtonContainer>
            <ToolbarDivider />
            <ButtonContainer>
              <MetadataElementsToolbarButton isDisabled={isDisabled} />
              <TemplatesAndPluginsToolbarButton isDisabled={isDisabled} />
              <CanvasAddFunnelMenuButton isDisabled={isDisabled} />
            </ButtonContainer>
          </CanvasToolbarPaper>
        </Box>
      </Fade>
  );
};
